import { defineStore } from 'pinia'

export const useSocketStore = defineStore('pos-ss', {
  state: () => ({
    // Connection state
    isConnected: false,
    socketId: null,
    isConnecting: false,
    error: null, // Connection error message
    socketConnectionStatus: '',
    socketConnectionColor: '',
    serverUrl: null, // Actual server URL we're connected to

    // Authentication state
    isAuthenticated: false,
    authError: null,
    subscribedChannels: {}, // { 'business-4-orders': true }
  }),
  actions: {
    // Actions to be called by the plugin
    setConnecting() {
      this.isConnecting = true
      this.isConnected = false
      this.error = null
    },
    setConnected(socketId, serverUrl = null) {
      this.isConnected = true
      this.isConnecting = false
      this.socketId = socketId
      this.error = null
      if (serverUrl) {
        this.serverUrl = serverUrl
      }
    },
    setDisconnected(code, reason) {
      this.isConnected = false
      this.isConnecting = false
      this.socketId = null
      this.isAuthenticated = false // Auth is lost on disconnect
      if (code !== 1000) { // 1000 is normal closure
        const reasonText = reason || 'Unknown'
        this.error = `Socket closed unexpectedly. Code: ${code}, Reason: ${reasonText}`
      }
    },
    setError(errorMessage) {
      this.isConnected = false
      this.isConnecting = false
      this.error = errorMessage
    },
    setAuthenticated(isAuth, error = null) {
      this.isAuthenticated = isAuth
      this.authError = error
    },
    setChannelSubscribed(channelName) {
      this.subscribedChannels[channelName] = true
    },
    setChannelUnsubscribed(channelName) {
      delete this.subscribedChannels[channelName]
    },
    clearAllSubscriptions() {
      this.subscribedChannels = {}
    },
  },
  // No persistence. Every field in this store is volatile — reflects
  // live state of the underlying SocketCluster connection. Persisting
  // them produced a real bug: after page reload, isConnected:true was
  // restored even though no actual socket existed. Components that gate
  // on `socketStore.isConnected` skipped their reconnect logic until
  // something else explicitly reset the flag — sockets stayed dead with
  // a green "Connected" indicator. Plus every state mutation triggered a
  // synchronous localStorage.setItem, which on a flaky connection meant
  // hundreds of writes per minute. Volatile state stays in memory only.
})
